import { type ChangeEventHandler } from 'react';

interface SwitchProps extends React.HTMLAttributes<HTMLInputElement> {
  size?: 'md' | 'lg' | 'xl';
  variant?: 'success' | 'info';
  label?: {
    left: string;
    right: string;
  };
  checked: boolean;
  disabled?: boolean;
  onChange?: ChangeEventHandler<HTMLInputElement>;
}

const Switch = ({
  checked,
  onClick,
  onChange,
  label,
  size = 'lg',
  variant = 'success',
  disabled,
  ...props
}: SwitchProps) => {
  const variants = {
    success: 'bg-grey-400 dark:bg-grey-700 peer-checked:bg-green-600 dark:peer-checked:bg-green-600',
    info: 'bg-grey-400 dark:bg-grey-700 peer-checked:bg-blue-600 dark:peer-checked:bg-blue-600',
  };

  const sizes = {
    md: 'h-3 w-5 after:h-2 after:w-2',
    lg: 'h-5 w-9 after:h-4 after:w-4',
    xl: 'h-6 w-11 after:h-5 after:w-5',
  };

  const fontSizes = {
    md: 'text-xs',
    lg: 'text-sm',
    xl: 'text-base',
  };

  const variantClass = variants[variant];
  const sizeClass = sizes[size];
  const fontSizeClass = fontSizes[size];

  return (
    <div className={'flex items-center gap-2 '}>
      {label?.left && (
        <p
          className={`${fontSizeClass} font-normal ${
            !checked ? 'text-grey-900' : 'text-grey-700'
          }`}
        >
          {label.left}
        </p>
      )}
      <label className="inline-flex relative items-center">
        <input
          {...props}
          onClick={onClick}
          type="checkbox"
          className="sr-only peer "
          checked={checked}
          onChange={onChange}
          disabled={disabled}
        />
        <span
          className={`${variantClass} ${sizeClass} ${disabled ? 'cursor-not-allowed opacity-50' : ''} focus:border focus:border-solid focus:outline-gray-105 bg-grey-200 rounded-full peer dark:bg-gray-700 peer-checked:after:translate-x-full  peer-checked:after:border-white after:absolute after:top-[50%] after:translate-y-[-50%] after:left-[2px] after:bg-white after:rounded-full after:transition-all`}
        ></span>
      </label>
      {label?.right && (
        <p
          className={`${fontSizeClass} font-normal ${
            checked ? 'text-grey-900' : 'text-grey-700'
          }`}
        >
          {label.right}
        </p>
      )}
    </div>
  );
};

export default Switch;
